import { makeStyles } from '@material-ui/core/styles';

export const useImageViewerDialogStyles = makeStyles(() => ({
  dialog: {
    padding: '8.5rem 1rem 2rem 1rem',
    height: '100%',
    width: '100%',
    minHeight: 200,
  },
}));
